interface CSVGeneratorProps {
  headers: string[];
  rows: (string | number)[][];
  filename: string;
}

export const generateAndDownloadCSV = ({ headers, rows, filename }: CSVGeneratorProps) => {
  if (rows.length === 0) {
    throw new Error('No data available to download');
  }

  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(cell => `"${String(cell || '').replace(/"/g, '""')}"`).join(','))
  ].join('\n');

  // Create and trigger download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}; 